import { zergApi } from "@/service/zerg";

class SettingPayrollService {
    async getPensionFundSetting(params) {
        try {
            const data = await zergApi.post('setting/payroll/get-pension-fund-settings', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async searchSettingContribution(params) {
        try {
            const data = await zergApi.post('setting/payroll/search-settings-contribution', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmpresas(params) {
        try {
            const data = await zergApi.post('setting/payroll/get-empresas', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new SettingPayrollService();